import { createContext } from "react";

const ListReload = createContext();

export default ListReload;